import { render, staticRenderFns } from "./marquis-de-calon.vue?vue&type=template&id=86842b30&scoped=true"
import script from "./marquis-de-calon.vue?vue&type=script&lang=js"
export * from "./marquis-de-calon.vue?vue&type=script&lang=js"
import style0 from "./marquis-de-calon.vue?vue&type=style&index=0&id=86842b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86842b30",
  null
  
)

export default component.exports